// ── Funded, or not ─────────────────────────────────────────────────────────
//
// One definition, because two screens answer this question and they must not
// disagree: the dashboard's Unfunded Draws tile counts a pile, and the draws
// report filters to the same pile. A tile that says six and a page that shows
// seven is a bug nobody can diagnose from either end.
//
// A draw is funded when it has a funded DATE. The empty string is checked
// alongside null because the column has carried both — a cleared date field
// from a form posts "" rather than null, and `!d.fundeddate` alone is true for
// both but says so by accident rather than on purpose.
export const isDrawFunded = (d) =>
  !!(d && d.fundeddate != null && String(d.fundeddate).trim() !== "");

export const isDrawUnfunded = (d) => !isDrawFunded(d);
